"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueTypePicker = void 0;
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makePicker_1 = __importDefault(require("../helpers/makePicker"));
exports.IssueTypePicker = (0, makePicker_1.default)((props) => {
    const { settings } = (0, useSelf_1.default)();
    return (react_1.default.createElement(Select_1.default, Object.assign({}, props), Object.values(settings.issueTypes).map(v => (react_1.default.createElement(MenuItem_1.default, { key: v.key, value: v.key },
        react_1.default.createElement(Text_1.default, null, v.title))))));
});
exports.default = exports.IssueTypePicker;
